import { getSpeechToken } from '@/api/speech'
import { parseJwtExp } from '@/utils/parseJwtExp'
import { TOKEN_EXPIRY_BUFFER_MS, TOKEN_FALLBACK_TTL_MS } from './constants'

interface CachedToken {
  token: string
  region: string
  expiresAt: number
}

class SpeechTokenManager {
  private cached: CachedToken | null = null

  async getValidToken(): Promise<{ token: string, region: string }> {
    const cached = this.cached
    if (cached && cached.expiresAt - Date.now() > TOKEN_EXPIRY_BUFFER_MS) {
      return { token: cached.token, region: cached.region }
    }
    const { token, region } = await getSpeechToken()
    const exp = parseJwtExp(token)
    const expiresAt = exp !== null ? exp * 1000 : Date.now() + TOKEN_FALLBACK_TTL_MS
    this.cached = { token, region, expiresAt }
    return { token, region }
  }

  clear() {
    this.cached = null
  }
}

export default SpeechTokenManager
